<template>
<div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
        <b-overlay :show="false" spinner-variant="primary" spinner-type="grow" spinner-large rounded="sm">
            <!-- Register v1 -->
            <b-card class="mb-0">
                <b-row>
                    <b-col sm="12" class="text-center">
                        <b-img fluid class="brand-logo" style="max-width:100%;" :src="client.logo" />
                    </b-col>
                </b-row>
                <div>
                    <b-card-title class="mb-1">
                        客戶預約登記 Guest Register
                    </b-card-title>
                    <b-card-text class="mb-2">
                        <div v-if="insert === true" v-html="message"></div>
                    </b-card-text>

                    <!-- form -->
                    <validation-observer ref="registerForm">
                        <h4 class="brand-text text-primary ml-1" v-if="valid === false">Invalid Link</h4>
                        <b-form v-if="insert === false && valid === true">
                            <!-- Username -->
                            <validation-provider #default="validationContext" name="Chinese Name">
                                <b-form-group label="姓名 Name" label-for="Chinese Name">
                                    <b-form-input id="" v-model="userData.zh_name" trim />

                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                           

                            <validation-provider #default="validationContext" name="email">
                                <b-form-group label="電子郵件 E-Mail" label-for="email">
                                    <b-form-input id="email" v-model="userData.email" trim />

                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider #default="validationContext" name="mobile" rules="required">
                                <b-form-group label="手提電話 Mobile" label-for="mobile">
                                    <b-form-input id="mobile" v-model="userData.mobile" trim />

                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>


                            <validation-provider #default="validationContext" name="性別 Gender" rules="required">
                                <b-form-group label="性別 Gender" label-for="gender">
                                    <v-select v-model="userData.gender" :reduce="gender => gender.value"  :options="genderOptions" :clearable="false" input-id="gender" />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <hr class="my-2"/>
                             <validation-provider #default="validationContext" name="性別 Gender" rules="required">
                                <b-form-group label="有意親臨的分店 Desired Branch" label-for="center">
                                    <v-select v-model="userData.center" :reduce="center => center.value" :options="centerOptions" :clearable="false" input-id="centers" />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            
                             <b-form-group  label="親臨時間" label-for="center">
                          
                                <flat-pickr
                                v-model="userData.appointment"
                                class="form-control"
                                :config="{ enableTime: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d H:i'}"
                                />
                            </b-form-group>

                            <hr class="my-2"/>
                            <b-button variant="primary" block type="button" @click="submit">
                                送出 Submit
                            </b-button>
                        </b-form>

                    </validation-observer>
                </div>

                <div class="text-center mt-3" style="font-size:10px;"><b>Power by CloudFit</b><br><span style="font-size:8px;color:#bbb;">{{ this.membership }}</span></div>

            </b-card>
            <!-- /Register v1 -->
        </b-overlay>
    </div>
</div>
</template>

<script>
import {
    ValidationProvider,
    ValidationObserver
} from 'vee-validate'
import {
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BOverlay,
    BForm,
    BImg,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BFormInvalidFeedback
} from 'bootstrap-vue'
import router from '@/router'
import flatPickr from 'vue-flatpickr-component'

import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
    required,
    email
} from '@validations'
import {
    togglePasswordVisibility
} from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

export default {
    components: {
        VuexyLogo,
        // BSV
        BCard,
        vSelect,
        BRow,
        BCol,
        BLink,
        BOverlay,
        BImg,
        BCardTitle,
        router,
        BCardText,
        BFormInvalidFeedback,
        BForm,
        flatPickr,
        BButton,
        BFormInput,
        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BFormCheckbox,
        // validations
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            membership: null,
            processing: false,
            regEmail: '',
            username: '',
            login: {
                mobile: null,
                code: null,
                sent: false
            },
            message: '',
            valid: true,
            password: '',
            loading: true,
            centerOptions:[],
            genderOptions:[
                {label:'Male 男',value:'M'},
                {label:'Female 女',value:'F'}
            ],
            userData: {
                zh_name: null,
                en_name: null,
                email: null,
                mobile: null,
                gender: null,
                campaign : null,
                source : null
            },
            status: '',
            insert: false,
            client: {
                client_name: null,
                web_key: null,
                logo: null
            },

            // validation rules
            required,
            email,
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
    },
    created() {
        this.get_client()
        if (this.$route.query.source !== null) {
            this.userData.source = this.$route.query.source
        }
        if (this.$route.query.campaign !== null) {
            this.userData.campaign = this.$route.query.campaign
        }
    },
    methods: {

        get_client() {
            this.$http.get(process.env.VUE_APP_API_BASE + `/client/` + router.currentRoute.params.client_alias + `/`)
                .then(res => {
                    if (res.data.result === false) {
                        this.valid = false
                    } else {
                        this.loading = false
                        this.client = res.data.client
                        this.centerOptions = res.data.centers
                    }
                })
        },
        submit() {
            this.$http.post(process.env.VUE_APP_API_BASE + '/lead-register/' + router.currentRoute.params.client_alias + '/', this.userData)
                .then(res => {
                    if (res.data.result === true) {
                        this.insert = true
                        //   this.$swal({
                        //     title: 'Success!',
                        //     text: '你成功註冊!',
                        //     icon: 'success',
                        //     showConfirmButton : false,
                        //     buttonsStyling: false,
                        //     backdrop: false,
                        //   })
                        this.message = res.data.message
                        if (this.membership !== null) {
                            //alert('https://www.cloudfit.pro/paylink/membership/'+this.membership+'/?member='+res.data.uuid);
                            this.$router.push('/paylink/membership/' + this.membership + '/?member=' + res.data.uuid).then(() => {})
                        }
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
